module.exports = __webpack_public_path__ + "static/media/cross2 (1).0df6e081.svg";